module.exports = __webpack_public_path__ + "img/btn__arrow__green.1c1ca067.svg";